import styled from 'styled-components';
import { StyledTextInput } from '../../pages/InputPage/InputPage.styled';

export const ManualAddressInputsContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 6px;
`;

export const ManualAddressInput = styled(StyledTextInput)`
  box-sizing: border-box;
  background-color: white;
  border: 2px solid ${(props) => props.theme.ecoMint};
  border-radius: 8px;
  width: 100%;
  height: '40px';
  display: ${(props) => (props.display ? props.display : 'flex')};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
  padding: 0 10px;
  z-index: 2;

  &:focus {
    border: 2px solid ${(props) => props.theme.highlightBlue};
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
  }
`;

export const StreetAddressInput = styled(ManualAddressInput)`
  grid-column: 1 / span 2;
`;

export const ToggleText = styled.div`
  position: absolute;
  font-size: 0.8rem;
  font-style: italic;
  text-align: left;
  grid-row: 3;
  /* grid-column: 1 / span 2; */
`;
